// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8429 ? "f58c171e" : chunkId) + "." + {"6174":"3199d3493c166acc","8429":"ca3506800044c223"}[chunkId] + ".js";
};